module.exports = __webpack_public_path__ + "static/img/Bachelor_010477.9d2d0b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010477.jpg
// module id = 173
// module chunks = 0